import { internal, template } from '../../vendor/elix.js';
import TpSelectBase from '../select/tp-select-base.js';
import WithSlotMixin from '../mixins/with-slot-mixin.js';

class TpChipSelect extends WithSlotMixin(TpSelectBase, 'leading') {

  get empty() {
    return this.selectedIndex <= 0;
  }

  get error() {
    return this[internal.state].error;
  }

  set error(error) {
    const hasError = error === true || error === 'true' || this.hasAttribute('error');
    this[internal.setState]({ error: hasError });
  }
  
  getContainerToAnnotateWithClassName() {
    return this[internal.ids].inner;
  }

  [internal.componentDidMount]() {
    super[internal.componentDidMount]();
    this.addEventListener('change', () => this[internal.render]({}));
    if(document && document.fonts && document.fonts.ready){
      document.fonts.ready.then(() => this.renderAutoWidth())
    }
  }

  [internal.render](changed) {
    super[internal.render](changed);
    this.renderEmptyClass();
    this.renderAutoWidth();
    this.renderError();
  }

  renderAutoWidth() {
    const selectedOption = this.selectedOptions.length
      ? this.selectedOptions[0]
      : this.options[0];

    const inner = this[internal.ids].inner;

    const autowidth = document.createElement('select');
    autowidth.id = 'autowidth';
    autowidth.appendChild(selectedOption.cloneNode(true));
    autowidth.className = inner.className;
    this.shadowRoot.appendChild(autowidth);

    inner.style.width = `${autowidth.clientWidth}px`;

    autowidth.remove();
  }

  renderError() {
    
    const inner = this[internal.ids].inner;

    if (this.error) {
      inner.classList.add('error');
    } else {
      inner.classList.remove('error');
    }
  }

  get [internal.template]() {

    return template.concat(
      super[internal.template],
      template.html`

        <style>

          #inner, #autowidth {
            border: none;
            border-radius: 17px;
            font-family: var(--tp-choice-chip-font-family);
            font-size: var(--tp-choice-chip-font-size);
            height: 34px;
            letter-spacing: normal;
            padding: 0px 12px;
            outline: none;
            white-space: nowrap;
            -webkit-appearance: none;
          }

          #inner {
            background-color: var(--tp-chip-select-background-color);
            color: var(--tp-choice-chip-font-color);
            cursor: pointer;
            margin-right: 0px;
            opacity: var(--tp-choice-chip-opacity);
          }

          #inner.with-leading-slot-contents,
          #autowidth.with-leading-slot-contents {
            padding-left: 44px;
          }

          #autowidth {
            bottom: 0px;
            height: 0px;
            left: 0px;
            overflow-y: hidden;
            position: absolute;
          }

          #inner, #inner:disabled, #inner:hover, #inner:focus, #inner:active {
            background-image: none;
          }

          #inner:hover:enabled,
          #inner:focus:enabled,
          #inner:active:enabled {
            opacity: var(--tp-choice-chip-opacity-active);
          }

          #inner.empty:not(.error):hover:enabled,
          #inner.empty:not(.error):focus:enabled,
          #inner.empty:not(.error):active:enabled {
            background-color: var(--tp-chip-select-background-color-active);
          }

          #inner:disabled {
            opacity: var(--tp-choice-chip-opacity-disabled);
          }

          #inner:not(.empty):not(.error) {
            background-color: var(--tp-choice-chip-background-color-selected);
            color: var(--tp-choice-chip-font-color-selected);
            opacity: var(--tp-choice-chip-opacity-active);
          }
          
          #inner.error {
            background-color: var(--tp-chip-select-background-color-error);
            color: var(--tp-choice-chip-font-color-selected);
            opacity: var(--tp-choice-chip-opacity-active);
          }

          #inner option {
            background-color: white;
            color: black;
          }

          slot[name=leading]::slotted(*) {
            pointer-events: none;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 12px;
          }
          </style>
      `
    );
  }
}

export default TpChipSelect;
